import { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PopUp from '../../Popup/logoutPopup';
import { useAppContext } from '../../Lib/contextLib';
import MediaService from '../../services/MediaService';

import './UnitNavigation.scss';
import UnitDayButton from './UnitDayButton';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';

const UnitNavigation = ({
  moduleName,
  module,
  backgroundPath,
  days,
  unitDestiny,
  nextDestiny,
  totalDays,
  onSurpriseClick,
  unit,
  animal
}) => {
  const { userHasAuthenticated } = useAppContext();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const checkGrade = () =>{
    if(totalDays <= module.day_completed){
      return false
    }

    if (unit === 1){
      switch (login.grade) {
        case 'Preschool':
          return false
        case 'Kindergarten':
          return false
        case '1st Grade':
          return module.day_completed >= 5 ? true : false
        case '2nd Grade':
          return false
        case '3rd Grade':
          return false
        case 'iPads Only':
          return false
        case 'Teacher Account':
          return false
        case 'Free Play':
          return false
        default:
          return false
      }
    }
    else if (unit === 2){
      switch (login.grade) {
        case 'Preschool':
          return false
        case 'Kindergarten':
          return false
        case '1st Grade':
          return false
        case '2nd Grade':
          return module.day_completed >= 4 ? true : false
        case '3rd Grade':
          return false
        case 'iPads Only':
          return false
        case 'Teacher Account':
          return false
        case 'Free Play':
          return false
        default:
          return false
      }
    }
    else if (unit === 3){
      switch (login.grade) {
        case 'Preschool':
          return false
        case 'Kindergarten':
          return false
        case '1st Grade':
          return false
        case '2nd Grade':
          return false
        case '3rd Grade':
          return false
        case 'iPads Only':
          return false
        case 'Teacher Account':
          return false
        case 'Free Play':
          return false
        default:
          return false
      }
    }
    else if (unit === 4){
      switch (login.grade) {
        case 'Preschool':
          return false
        case 'Kindergarten':
          return false
        case '1st Grade':
          return false
        case '2nd Grade':
          return false
        case '3rd Grade':
          return false
        case 'iPads Only':
          return false
        case 'Teacher Account':
          return false
        case 'Free Play':
          return false
        default:
          return false
      }
    }

  }
  const [showAccelerate, setShowAccelerate] = useState(checkGrade());





  const unitNavBtn = MediaService.getImage(
    '/Images/Worlds/WorldMap_Large_Unit1_5of5.png',
    login
  );
  const logoutBtn = MediaService.getImage('/Module1Images/Logout.png', login);
  const giftBtn = MediaService.getImage('/Images/Gift.png', login);

  const togglePopup = () => setIsOpen(!isOpen);

  return (
    <div className={`module ${moduleName}`}>
      <div className='module-content'>
        <header>
          <div className='actions'>
            <button onClick={togglePopup}>
              <img
                className='logoutBtnNav'
                src={logoutBtn}
                alt='Logout Button'
              />
            </button>

            <button onClick={() => navigate(unitDestiny)}>
              <img
                className='unitBtnNav'
                src={unitNavBtn}
                alt='Unit Nav Button'
              />
            </button>
          </div>
          <h1>{login.firstname}&apos;s Journey</h1>

          <div className='actions'>
            {module.day_completed >= totalDays && (
              <button onClick={onSurpriseClick}>
                <img className='surprise' src={giftBtn} alt='Surprise Video' />
              </button>
            )}
          </div>
        </header>

        <div
          className='module-container'
          style={{
            backgroundImage: `url(${backgroundPath})`,
          }}
        >
          {days.map((day) => (
            <UnitDayButton
              key={`day_${day.dayNumber}`}
              module={module}
              moduleName={moduleName}
              day={day.dayNumber}
              filledImageUrl={day.filledImageUrl}
              outlinedImageUrl={day.outlinedImageUrl}
              destiny={day.destiny}
              influencerMessageCallback={() => setShowPopup(true)}
              unit={unit}
              teacher={(login.grade === "Teacher Account" || login.grade  === "Free Play") ? true : false}
            />
          ))}

          {module.day_completed >= totalDays && (
            <footer className='module-footer'>
              <button
                id='bounce'
                className='bounce'
                onClick={() => navigate(nextDestiny)}
              >
                NEXT &#62;
              </button>
            </footer>
          )}
        </div>

        {isOpen && (
          <PopUp
            content={
              <>
                <b id='title'>
                  Are you sure you want to leave?
                  <br />
                </b>
                <button
                  id='logoutButton1'
                  className='logoutButton'
                  onClick={() => {
                    navigate('/');
                    userHasAuthenticated(false);
                    localStorage.setItem('token', 'false');
                  }}
                >
                  YES
                </button>
                <button
                  id='logoutButton2'
                  className='logoutButton'
                  onClick={togglePopup}
                >
                  NO
                </button>
              </>
            }
            handleClose={togglePopup}
          />
        )}
      </div>

      {showAccelerate && (
        <audio autoPlay>
          <source src={presentSound}></source>
        </audio>
      )}

      {showAccelerate && (
        <PopUp
          content={
            <>
              <img src={animal} />
              <br />
              <b id="title">
                Awesome job! You completed this level.
                <br />
                You can stay on this level to keep practicing these skills, or level up to the next skill.
                <br />
              </b>
              <br />
              <button id="logoutButton2" className="logoutButton" onClick={() => setShowAccelerate(false)}> <b id="title">Stay </b> </button>
              <button id="logoutButton1" className="logoutButton" onClick={() => navigate(nextDestiny)}><b id="title"> Level Up</b></button>
            </>
          }
        />
      )}

      {showPopup && (
        <PopUp
          content={
            <>
              <p>
                Please have your teacher or parent assign an influencer to your account.
                <br />
                Once the main influencer has been assigned, log out and then log back in to proceed.
              </p>
              <button onClick={() => setShowPopup(false)}>OKAY</button>
            </>
          }
        />
      )}
    </div>
  );
};
export default UnitNavigation;
